module.exports = __webpack_public_path__ + "img/2-center.59bd4ffb.png";